/**
 * This is the entry file for webpack/config/admin.js
 */


// Nette forms
import netteForms from 'nette-forms';
window.Nette = netteForms;
netteForms.initOnLoad();

// Application
import '/webpack/assets/js/admin/flashMessenger.js';
import '/webpack/assets/js/admin/netteFormsExtension.js';
import '/webpack/assets/js/admin/sortable.js';
import '/webpack/assets/js/admin/general.js';
